import React from 'react';
import { MdDashboard, MdSupportAgent } from 'react-icons/md';
import { CgProfile } from 'react-icons/cg';
import { IoMdContacts } from "react-icons/io";
import { FiPhone } from "react-icons/fi";

import SvgColor from '../../../components/svg-color';
import { FaGlobe } from 'react-icons/fa';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const adminConfig = [
  {
    title: 'Users',
    path: '/dashboard/users',
    icon: <IoMdContacts />,
  },
  {
    title: 'Nodes',
    icon: icon('ic_analytics'),
    path: '/dashboard/admin/monitors',
  },
  {
    title: 'Domains',
    icon: <FaGlobe />,
    path: '/dashboard/admin/domain-monitors',
  },
  {
    title: 'Contact Sales',
    path: '/dashboard/contact-sales',
    icon: <FiPhone />,
  },
  {
    title: 'News Update',
    icon: <MdDashboard />,
    path: '/dashboard/news-update',
  },
  {
    title: 'Profile',
    icon: <CgProfile />,
    path: '/dashboard/profile',
  }
];

export default adminConfig;
